// ActivityAdd.js
import React, { useState, useRef, useEffect } from 'react';
import DashboardLayout from './DashboardLayout';
import ReducedContent from './ReducedContent';
import { Alert } from 'react-bootstrap';
import { fetchOptions, fetchGrades, createCategory } from '../../api/api'

const CategoryAdd = () => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [formValues, setFormValues] = useState({
    materia: '',
    ano: '',
    nome: '',
  });
  const [isFormValidated, setIsFormValidated] = useState(false);
  const formRef = useRef(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const [subjects, setSubjects] = useState([]);
  const [grades, setGrades] = useState([]);

  // Fetch subjects on component mount
  useEffect(() => {
    const fetchInitialSubjects = async () => {
      try {
        const options = await fetchOptions(null, null);
        setSubjects(options.subjects || []);
      } catch (error) {
        // console.error("Error fetching subjects:", error);
      }
    };
    fetchInitialSubjects();
  }, []);

  // Fetch grades when subject changes
  useEffect(() => {
    const fetchGradesForSubject = async () => {
      if (!formValues.materia) return;
      try {
        const grades = await fetchGrades();

        setGrades(grades || []);
      } catch (error) {
        // console.error("Error fetching grades:", error);
      }
    };
    fetchGradesForSubject();
  }, [formValues.materia]);

  const handleSubmit = async (event) => {
    setIsButtonDisabled(true);

    try {
      event.preventDefault();
      const form = formRef.current;
      setIsFormValidated(true);
    
      if (form.checkValidity() === false) {
        event.stopPropagation();
        setShowErrorAlert(true);
        
      } else {
          await createCategory(formValues.nome, formValues.materia, formValues.ano);
          
          setShowSuccessAlert(true);

          // Clear form values
          setFormValues({
            materia: '',
            ano: '',
            nome: '',
          });
    
        
          // Remove validation styles
          form.classList.remove('was-validated');
          setIsFormValidated(false);
      
      }
    } catch (error) {
      setShowErrorAlert(true);
    }
    setIsButtonDisabled(false);
    setTimeout(() => {
      setShowSuccessAlert(false);
      setShowErrorAlert(false);
    }, 3000);
  };

  return (
    <div>
      <DashboardLayout title="Adicionar Categoria">
        <ReducedContent>

          {/* Success Alert */}
          {showSuccessAlert && (
            <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible>
              Categoria adicionada com sucesso!
            </Alert>
          )}

          {/* Error Alert */}
          {showErrorAlert && (
            <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible>
              Erro ao adicionar categoria. Verifique os campos obrigatórios.
            </Alert>
          )}

          <form
            ref={formRef}
            className={`g-3 needs-validation ${isFormValidated ? 'was-validated' : ''}`}
            noValidate
            onSubmit={handleSubmit}
          >
         
            <div className="input-group mb-3">
              <span className="input-group-text">Nome</span>
              <input
                disabled={isButtonDisabled}
                className="form-control"
                aria-label="With textarea"
                name="nome"
                value={formValues.nome}
                onChange={handleChange}
                required
              ></input>
              <div className="invalid-feedback">
                Forneça um nome.
              </div>
            </div>
           
            <div className="input-group mb-3">
              <label className="input-group-text" htmlFor="inputGroupSelect02">Matéria</label>
              <select
                disabled={isButtonDisabled}
                className="form-select"
                id="inputGroupSelect02"
                name="materia"
                value={formValues.materia}
                onChange={handleChange}
                required
              >
                <option value="" disabled>Escolha...</option>
                {subjects.map(subject => (
                  <option key={subject.uuid} value={subject.uuid}>
                    {subject.name}
                  </option>
                ))}
              </select>
              <div className="invalid-feedback">
                Escolha uma matéria.
              </div>
            </div>


             {/* Ano (Grade) Select */}
             <div className="input-group mb-3">
              <label className="input-group-text" htmlFor="inputGroupSelect03">Ano</label>
              <select
                className="form-select"
                id="inputGroupSelect03"
                name="ano"
                value={formValues.ano}
                onChange={handleChange}
                required
                disabled={!grades.length || isButtonDisabled}
              >
                <option value="" disabled>Escolha...</option>
                {grades.map((grade) => (
                  <option key={grade.uuid} value={grade.uuid}>
                  {grade.name}
                </option>
                ))}
              </select>
              <div className="invalid-feedback">
                Escolha um ano.
              </div>
            </div>
            <div className="col-12">
            <button
                disabled={isButtonDisabled} 
                className="btn btn-primary" 
                type="submit"
              >
                {isButtonDisabled ? 'Processando...' : 'Adicionar'}
              </button>
            </div>
           
          </form>
        </ReducedContent>
      </DashboardLayout>
    </div>
  );
};

export default CategoryAdd;
